export interface ValidationMixins {
  scrollToErrors(): void;
}

export const validationMixins: ValidationMixins = {
  scrollToErrors() {
    this.$nextTick(() => {
      scrollToFirstError.call(this);
    });
  },
};

function scrollToFirstError() {
  let offset = 0;

  const offsetElement = document.querySelector<HTMLElement>('.js-header');

  if (!offsetElement)
    console.error('No header found, make sure the class js-header is added to the navigation component');

  if (offsetElement) offset = -(offsetElement.offsetHeight + 80);

  const firstError =
    Array.from(document.querySelectorAll('.js-validation-error')).find(elm => elm.textContent?.trim()) ||
    document.querySelector('.error');

  firstError && this.$scrollTo(firstError, { offset, force: true });
}
